export default {
  groups: [],
  placeholders: [],

  document: undefined,
  associateDocuments: [],
  associateDocumentsSync: undefined,
  associateDynamicForm: {},
  associateDynamicFormAvailability: {},

  templates: {}
}
